<template>
  <div>
    <b-card class="mt-4">
      <div v-show="!isLoaded">
        <Loading ref="loadingSpinner"></Loading>
      </div>
      <div v-if="isLoaded">
        <b-overlay :show="busy" rounded="sm">
          <div class="row pt-3 pb-3">
            <div class="col">
              <h3>Receptury dla produktów oblewanych</h3>
            </div>
            <div class="col">
              <button type="button" class="btn btn-primary float-right" @click="OpenModal">
                <i class="fas fa-plus-circle fa-1x"></i> Dodaj recepturę
              </button>
            </div>
          </div>

          <table class="table table-striped table-sm">
            <tr>
              <th>Nazwa</th>
              <th>Typ oblewanego produktu</th>
              <th>Składniki</th>
              <th>Akcje</th>
            </tr>
            <tr v-for="item in items" :key="item.id">
              <td>
                <div class="raw-material-eco" v-if="item.recipeType == 0">
                  EKO - {{ item.name }}
                </div>
                <div class="raw-material-convention" v-else>
                  Konwencja - {{ item.name }}
                </div>
              </td>
              <td>
                <v-select :options="coatingProductTypes" :disabled="!item.isEdit" label="name" v-model="item.type"
                  :reduce="(x) => x.id"></v-select>
              </td>
              <td>
                <table class="table table-striped table-sm">
                  <tr>
                    <th>Nazwa</th>
                    <th>Waga (kg)</th>
                  </tr>
                  <tr v-for="ingredient in item.ingredients" :key="ingredient.name">
                    <td>{{ ingredient.name }}</td>
                    <td>{{ ingredient.weight }}</td>
                  </tr>
                </table>
              </td>
              <td class="div-icons-area">
                <span @click="OpenModalInEdit(item)" v-b-tooltip.hover title="Edytuj recepturę">
                  <i class="fas fa-edit fa-lg"></i></span>
                <span v-b-tooltip.hover title="Usuń recepturę" @click="RemoveItem(item)">
                  <i class="fas fa-trash fa-lg"></i>
                </span>
              </td>
            </tr>
          </table>

          <b-modal size="lg" no-close-on-backdrop v-model="modal.showModal" title="Edycja receptury" ok-title="Zapisz"
            cancel-title="Anuluj" @ok="SaveData()">
            <label>Nazwa receptury</label>
            <input type="text" class="form-control" placeholder="Nazwa receptury" v-model="modal.name" />
            <hr />
            <label>Rodzaj oblewanego produktu</label>
            <v-select :options="coatingProductTypes" label="name" v-model="modal.type" :reduce="(x) => x.id"></v-select>
            <label>Rodzaj receptury</label>
            <v-select label="name" :options="recipeTypesSrc" v-model="modal.recipeType" :reduce="(x) => x.id"></v-select>

            <hr />
            <div>
              <div class="row">
                <div class="col-4 font-weight-bold">Kuwertury</div>
                <div class="col-8">
                  <button type="button" class="btn btn-primary float-right" @click="AddCouverture">
                    <i class="fas fa-plus-circle fa-1x"></i> Dodaj kuwerturę
                  </button>
                </div>
              </div>

              <CouvertureItem v-for="item in modal.couvertures" :key="item.id" :selectedItem="item"></CouvertureItem>
              <hr />
            </div>
            <div class="row">
              <div class="col-4 font-weight-bold">Produkty</div>
              <div class="col-8">
                <button type="button" class="btn btn-primary float-right" @click="AddProduct">
                  <i class="fas fa-plus-circle fa-1x"></i> Dodaj produkt
                </button>
              </div>
            </div>
            <ProductItem v-for="item in modal.products" :key="item.id" :selectedItem="item"></ProductItem>
          </b-modal>
        </b-overlay>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import urlConfig from "../../../../mixins/url";
import toastr from "../../../../mixins/toastr";
import Loading from "../../../Common/Loading";
import CouvertureItem from "./RecipesCoating_CouvertureItem";
import ProductItem from "./RecipesCoating_ProductItem";
import recipesMixins from '../../../../mixins/recipes'
import deliveryMixins from '../../../../mixins/delivery'

export default {
  name: "RecipesCoatingAdministration",
  components: { Loading, CouvertureItem, ProductItem },
  mixins: [urlConfig, toastr, recipesMixins, deliveryMixins],
  computed: {
    recipeTypesSrc() {
      return this.$store.state.coatingProductRecipe.recipesTypes;
    },
  },
  mounted() {
    this.coatingProductTypes = this.$store.state.coatingProduct.typeList;
    this.$store.dispatch("getDeliveryFromData");
    this.$store.dispatch("getCuvertureFormData");
    this.Getitems();
  },
  data() {
    return {
      couvertureMaterialType: 1,
      quesationText: "Czy napewno chcesz usunać recepturę: ",
      newItemSuccess: "Nowa receptura został dodana: ",
      editItemSuccess: "Receptura został zedytowana.",
      busy: false,
      items: [],
      isLoaded: false,
      modal: {
        name: "",
        couvertures: [],
        products: [],
        showModal: false,
        isEdit: false,
        type: 0,
        recipeType: 0
      },
      coatingProductTypes: []
    };
  },
  watch: {
    "modal": {
      handler(value) {
        const isAnyKonwencjaProducts = value.products.filter(x => x?.rawMaterial?.productType == this.rawMaterialTypeKonwencja).length > 0
        const isAnyKonwencjaCouvertures = value.couvertures.filter(x => x?.couverture?.recipeType == this.rawMaterialTypeKonwencja).length > 0

        this.modal.recipeType = (isAnyKonwencjaCouvertures || isAnyKonwencjaProducts) ? this.rawMaterialTypeKonwencja : this.rawMaterialTypeEko
      },
      deep: true
    }
  },
  methods: {
    AddCouverture() {
      this.modal.couvertures.push({ couvertureWeight: 0 });
    },
    AddProduct() {
      this.modal.products.push({ rawMaterialWeight: 0, rawMaterial: {} });
    },
    OpenModal() {
      this.modal.showModal = true;
      this.modal.name = "";
      this.modal.type = 0;
      this.modal.couvertures = [];
      this.modal.products = [];
      this.modal.isEdit = false;
      this.modal.recipeType = 0;
    },
    OpenModalInEdit(item) {
      this.modal.showModal = true;
      this.modal.name = item.name;
      this.modal.type = item.type;
      this.modal.id = item.id;
      this.modal.isEdit = true;
      this.modal.couvertures = [];
      this.modal.products = [];
      this.modal.recipeType = item.recipeType;

      item.ingredients.forEach((x) => {
        if (x.materialType == this.couvertureMaterialType) {
          this.modal.couvertures.push({
            couverture: {
              id: x.ingredientId,
              name: x.name,
              recipeType: x.productType
            },
            couvertureWeight: x.weight,
          });
        } else {
          this.modal.products.push({
            rawMaterial: {
              id: x.ingredientId,
              name: x.name,
              productType: x.productType
            },
            rawMaterialWeight: x.weight,
          });
        }
      });
    },
    Getitems() {
      const that = this;
      this.getCoatingRecipes()
        .then(function (response) {
          response.data.forEach(function (entry) {
            entry.isEdit = false;
          });
          that.items = response.data;
          that.isLoaded = true;
        })
        .catch(function (e) {
          console.log(e);
          var ref = that.$refs.loadingSpinner;
          ref.ShowErrorMessage(e);
          that.isLoaded = false;
        });
    },
    AddItem() {
      this.items.push({ isEdit: true });
    },
    SaveData() {
      if (this.modal.isEdit) {
        this.UpdateItem();
      } else {
        this.SaveNewItem();
      }
    },

    Mapingredients() {
      var couvertures = this.modal.couvertures
        .filter((x) => x.couverture != undefined)
        .map((x) => ({
          name: x.couverture.name,
          weight: x.couvertureWeight,
          ingredientId: x.couverture.id,
          materialType: 1,
          productType: x.couverture.recipeType
        }));

      var products = this.modal.products
        .filter((x) => x.rawMaterial != undefined)
        .map((x) => ({
          name: x.rawMaterial.name,
          weight: x.rawMaterialWeight,
          ingredientId: x.rawMaterial.id,
          materialType: 2,
          productType: x.rawMaterial.recipeType
        }));

      var ingredients = couvertures.concat(products);
      return ingredients;
    },

    SaveNewItem() {
      var url = `${this.url.serverUrl}${this.url.RecipeCoating.CreateRecipe}`;
      var that = this;
      this.busy = true;

      //TODO: NIe dodawać kuwertur przy wysyłce
      var ingredients = this.Mapingredients();

      axios
        .post(url, {
          name: this.modal.name,
          type: this.modal.type,
          ingredients: ingredients,
          recipeType: this.modal.recipeType,
        })
        .then(function (response) {
          that.DisplaySuccess("Sukces!", that.newItemSuccess + that.modal.name);
          that.busy = false;
          that.items.push({
            id: response.data,
            name: that.modal.name,
            ingredients: ingredients,
            type: that.modal.type,
            recipeType: that.modal.recipeType,

          });
        })
        .catch(function (e) {
          that.busy = false;
          console.log(e);
          that.DisplayError("Błąd!", e);
        });
    },

    UpdateItem() {
      var url = this.url.serverUrl + this.url.RecipeCoating.EditRecipe;
      var that = this;
      this.busy = true;
      var ingredients = this.Mapingredients();

      axios
        .post(url, {
          id: this.modal.id,
          name: this.modal.name,
          ingredients: ingredients,
          type: this.modal.type,
          recipeType: this.modal.recipeType,
        })
        .then(function () {
          that.DisplaySuccess("Sukces!", that.editItemSuccess);
          that.busy = false;
          that.Getitems();
        })
        .catch(function (e) {
          that.busy = false;
          console.log(e);
          that.DisplayError("Błąd!", e);
        });
    },

    RemoveItem(item) {
      if (confirm(this.quesationText + item.name)) {
        var that = this;
        var url = this.url.serverUrl + this.url.RecipeCoating.RemoveRecipe;
        this.busy = true;
        axios
          .post(url, { id: item.id })
          .then(function () {
            that.items = that.items.filter((x) => x.id != item.id);
            that.busy = false;
          })
          .catch(function (e) {
            console.log(e);
            that.busy = false;
            that.DisplayError("Błąd!", e);
          });
      }
    },
  },
};
</script>
